import { render } from "./PersonaInfo.vue?vue&type=template&id=333f2e92&scoped=true"
import script from "./PersonaInfo.vue?vue&type=script&lang=js"
export * from "./PersonaInfo.vue?vue&type=script&lang=js"

import "./PersonaInfo.vue?vue&type=style&index=0&id=333f2e92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333f2e92"]])

export default __exports__